import React from 'react';

import CategoryLink from '../categories/category-link';

import '../../styles/common/topic-links.scss';

const TopicLinks = (props) => (
  <>
  {props.categories ? (
    <ul className="topic-links">
      {props.categories.map((category, idx) => (
        <li key={`category-link-${idx}`}>
          <CategoryLink category={ category } />
        </li>
      ))}
    </ul>
  ) : null}
  </>
);

export default TopicLinks;
